import React, { useEffect } from "react";
import { connect } from "react-redux";
import Layout from "components/layout";
import { bindActionCreators } from "redux";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsScreenDashboard {
  userData?: IUserData;
}

interface IDispatchProps {
  userSessionMenuItemActive?: (...args) => void;
}

export type IProps = IPropsScreenDashboard & IDispatchProps;

const Dashboard = ({ userData, userSessionMenuItemActive }: IProps) => {
  const TITLE_PAGE = useTranslation({ id: "dashboard" });

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.DASHBOARD);
  }, [userSessionMenuItemActive]);

  return (
    <Layout title={TITLE_PAGE} isLoading={false} role={userData.role}>
      <div>Dashboard</div>
    </Layout>
  );
};
const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  userData: state.UserSession.userData,
});

export default connect(mapStateToProps, mapDispatchToActions)(Dashboard);
